"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MPUProgressbar_1 = require("./animejs/MPUProgressbar");
// Initialisiere die MPUProgressbar-Klasse, wenn das DOM vollständig geladen ist
document.addEventListener('DOMContentLoaded', function () {
    try {
        // Erstelle eine Instanz der MPUProgressbar-Klasse
        new MPUProgressbar_1.MPUProgressbar('.mpuprogressbar');
    }
    catch (error) {
        if (error instanceof Error) {
            console.error(error.message);
        }
        else {
            console.error('An unknown error occurred');
        }
    }
});
